import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Landing from "@/pages/Landing";
import Upload from "@/pages/Upload";
import Result from "@/pages/Result";
import AuthCallback from "@/pages/AuthCallback";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import SiteFooter from "@/components/SiteFooter";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";

function Router() {
    const location = useLocation();
    // Detect OAuth callback synchronously (during render, not useEffect) so
    // the session_id is exchanged before any /me check fires.
    if (location.hash?.includes("session_id=")) return <AuthCallback />;
    return (
        <>
            <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/upload" element={<Upload />} />
                <Route path="/result" element={<Result />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
            </Routes>
            <SiteFooter />
        </>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Router />
                </AuthProvider>
            </BrowserRouter>
            <Toaster theme="dark" position="top-center" />
        </div>
    );
}

export default App;
